import { CommonResponse, CommonResponseList } from 'src/model/common';
import { CompanyAggregatedByBOL, CompanyTradeDataBOLs, PortsAggregatedByBOL, TradeDataMarketAnalytics } from 'src/model/tradeData';
import {getBlobRequest, getRequest} from 'src/services/api/http';
import { TypeBuyerSupplier, TypeDataGranularLevel, TypePortData } from 'src/utils/constants/enum';
import { URL_ENDPOINT } from 'src/utils/constants/service';

const CompanyTradeDataService = {
  getListCTDBOLs,
  getListCTDCompanyAggregatedByBOL,
  getChartCTDCompanyAggregatedByBOL,
  getMapCTDCompanyAggregatedByBOL,
  getCompetitorTreemap,
  getCompetitorList,
  getCompetitorWorldMap,
  getListCTDPortsAggregatedByBOL,
  getChartCTDPortsAggregatedByBOL,
  getMapCTDPortsAggregatedByBOL,
  getCTDMarketAnalyticsChart,
  getCTDMarketAnalyticsList,
  getTransactionsCount,
  checkCompanyTradeDateTabIsExist,
  getCompanyTradeDataHSCodeChart,
  getCompanyTradeDataHSCodeList,
  getTransactionsPaymentStatus,
  getCompanyDetail,
  exportListBOLs
};

function getListCTDBOLs(id: string, query: any) {
  const url = URL_ENDPOINT.companyTradeData.transactions;
  return getRequest(url, query, new CompanyTradeDataBOLs()) as Promise<CompanyTradeDataBOLs>;
}

function getListCTDCompanyAggregatedByBOL(id: string, type: TypeBuyerSupplier, query: any) {
  const url = URL_ENDPOINT.companyTradeData[type].list.replace(':id', id);
  return getRequest(url, query, new CompanyAggregatedByBOL()) as Promise<CompanyAggregatedByBOL>;
}

function getChartCTDCompanyAggregatedByBOL(id: string, type: TypeBuyerSupplier, query: any) {
  const url = URL_ENDPOINT.companyTradeData[type].chart.replace(':id', id);
  return getRequest(url, query, new CompanyAggregatedByBOL()) as Promise<CompanyAggregatedByBOL>;
}

function getMapCTDCompanyAggregatedByBOL(id: string, type: TypeBuyerSupplier, query: any) {
  const url = URL_ENDPOINT.companyTradeData[type].map.replace(':id', id);
  return getRequest(url, query, new CompanyAggregatedByBOL()) as Promise<CompanyAggregatedByBOL>;
}

function getListCTDPortsAggregatedByBOL(id: string, type: TypePortData, query: any) {
  const url = URL_ENDPOINT.companyTradeData[type].list;
  return getRequest(url, query, new PortsAggregatedByBOL()) as Promise<PortsAggregatedByBOL>;
}

function getChartCTDPortsAggregatedByBOL(id: string, type: TypePortData, query: any) {
  const url = URL_ENDPOINT.companyTradeData[type].chart;
  return getRequest(url, query, new PortsAggregatedByBOL()) as Promise<PortsAggregatedByBOL>;
}

function getMapCTDPortsAggregatedByBOL(id: string, type: TypePortData, query: any) {
  const url = URL_ENDPOINT.companyTradeData[type].map;
  return getRequest(url, query, new PortsAggregatedByBOL()) as Promise<PortsAggregatedByBOL>;
}
function getCompetitorTreemap(id: string, query: Record<string, string | number>) {
  const url = URL_ENDPOINT.companyTradeData.competitor.chart.replace(':id', id);
  return getRequest(url, query, new CompanyAggregatedByBOL()) as Promise<CompanyAggregatedByBOL>;
}

function getCompetitorList(id: string, query: Record<string, string | number>) {
  const url = URL_ENDPOINT.companyTradeData.competitor.list.replace(':id', id);
  return getRequest(url, query, new CompanyAggregatedByBOL()) as Promise<CompanyAggregatedByBOL>;
}

function getCompetitorWorldMap(id: string, query: Record<string, string | number>) {
  const url = URL_ENDPOINT.companyTradeData.competitor.map
  return getRequest(url, query, new CompanyAggregatedByBOL()) as Promise<CompanyAggregatedByBOL>;
}

function getTransactionsCount(query: any) {
  const url = URL_ENDPOINT.companyTradeData.transactionsCount
  return getRequest(url, query, { data: 0, status_code: 200 }) as Promise<{ data: number }>;
}

function getCTDMarketAnalyticsChart(id: string, query: any, granularLevel: TypeDataGranularLevel) {
  const url = URL_ENDPOINT.companyTradeData.analytics.chart + `/${granularLevel}`;
  return getRequest(url, query, new TradeDataMarketAnalytics()) as Promise<TradeDataMarketAnalytics>;
}

function getCTDMarketAnalyticsList(id: string, query: any, granularLevel: TypeDataGranularLevel) {
  const url = URL_ENDPOINT.companyTradeData.analytics.list + `/${granularLevel}`;
  return getRequest(url, query, new TradeDataMarketAnalytics()) as Promise<TradeDataMarketAnalytics>;
}

function checkCompanyTradeDateTabIsExist(company_id = '', params = {}) {
  const url = URL_ENDPOINT.companyTradeData.checkCompanyTradeDataTabIsExist
  return getRequest(url, params) as Promise<CommonResponse>;
}
function getCompanyTradeDataHSCodeChart(params: Record<string, any>) {
  const url = URL_ENDPOINT.companyTradeData.hsCode.chart
  return getRequest(url, params, new CommonResponseList()) as Promise<IResponse<TypeCompanyTradeDataHSCode>>;
}
function getCompanyTradeDataHSCodeList(params: Record<string, any>) {
  const url = URL_ENDPOINT.companyTradeData.hsCode.list
  return getRequest(url, params, new CommonResponseList()) as Promise<IResponseList<TypeCompanyTradeDataHSCodeList>>;
}
function getTransactionsPaymentStatus(query: any) {
  const url = URL_ENDPOINT.companyTradeData.transactionsPaymentStatus;
  return getRequest(url, query) as Promise<{ data: { payment_status: boolean } }>;
}

function getCompanyDetail(id = '') {
  const url = URL_ENDPOINT.companyTradeData.companyDetail.replace(':id', id)
  return getRequest(url, new CommonResponse()) as Promise<IResponse<TradeDataCompanyDetail>>;
}

function exportListBOLs(query: string) {
  const url = URL_ENDPOINT.companyTradeData.exportListBOLs + '?' + query;
  return getBlobRequest(
    url,
    {},
    {
      accept: 'application/json',
    },
  );
}

export default CompanyTradeDataService;
